import { render, staticRenderFns } from "./SlButton.vue?vue&type=template&id=263afdd3&"
import script from "./SlButton.vue?vue&type=script&lang=js&"
export * from "./SlButton.vue?vue&type=script&lang=js&"
import style0 from "./SlButton.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports